<template>
  <div class="operation-item">
    <block-title title="下载模板" class="item-content">
      <a-row class="exportStyle">
        <a-col class="product-flg" :span="11" :offset="0">
          <div
            :class="typeIndex === UPLOADTYPE.SKU_CATEGORY ? 'radioBox radioBoxActive' : 'radioBox'"
            @click="editTypeIndex(UPLOADTYPE.SKU_CATEGORY)"
          >
            <img v-if="typeIndex === UPLOADTYPE.SKU_CATEGORY" class="activeImg" src="@/assets/img/icon_select.png" alt="">
            <p class="exportTitle">使用货品品类导入</p>
            <!-- <a-radio class="exportTitle" :checked="typeIndex === UPLOADTYPE.SKU_CATEGORY ? true : false">使用货品品类导入</a-radio> -->
            <p class="skuStyle">表格中填写货品品类，不填写sku明细</p>
            <div class="batchBtnStyle" @click="downloadExcelTemplate(TEMPLATETYPE.SKU_CATEGORY, TEMPLATETYPE.SKU_CATEGORY.type)">
              <img src="@/assets/img/icon/xlsx.png" />
              批量下单模板（使用货品品类）
              <img class="icon_load" :src="typeIndex === UPLOADTYPE.SKU_CATEGORY ? downloadField : downloads" />
            </div>
          </div>
        </a-col>
        <a-col :span="11" class="leftStyle product-flg" :offset="0">
          <div
            :class="typeIndex === UPLOADTYPE.SKU_CODE ? 'radioBox radioBoxActive' : 'radioBox'"
            @click="editTypeIndex(UPLOADTYPE.SKU_CODE)"
          >
            <img v-if="typeIndex === UPLOADTYPE.SKU_CODE" class="activeImg" src="@/assets/img/icon_select.png" alt="">
            <p class="exportTitle">使用货品明细导入</p>
            <!-- <a-radio class="exportTitle" :checked="typeIndex === UPLOADTYPE.SKU_CODE ? true : false">使用货品明细导入</a-radio> -->
            <p class="skuStyle">
              表格中需要填写sku明细
              <!-- <span @click="downloadDetails('货品明细', FILEURL.CUSTOMER_SKU_EXPORT)">下载货品明细表</span> -->
            </p>
            <div class="batchBtnStyle" @click="downloadExcelTemplate(TEMPLATETYPE.SKU_CODE, TEMPLATETYPE.SKU_CODE.type)">
              <img src="@/assets/img/icon/xlsx.png" />
              批量下单模板（使用货品明细）
              <img class="icon_load" :src="typeIndex === UPLOADTYPE.SKU_CODE ? downloadField : downloads" />
            </div>
          </div>
        </a-col>
        <a-col class="product-flg" :span="11" :offset="0">
          <div
            :class="typeIndex === UPLOADTYPE.SPECIAL_TEMPLATE ? 'radioBox radioBoxActive' : 'radioBox'"
            @click="editTypeIndex(UPLOADTYPE.SPECIAL_TEMPLATE)"
          >
            <img v-if="typeIndex === UPLOADTYPE.SPECIAL_TEMPLATE" class="activeImg" src="@/assets/img/icon_select.png" alt="">
            <p class="exportTitle">使用专用模板导入</p>
            <!-- <a-radio class="exportTitle" :checked="typeIndex === UPLOADTYPE.SPECIAL_TEMPLATE ? true : false">使用专用模板导入</a-radio> -->
            <p class="skuStyle">
              表格可支持按各种计费方式下单，需要填写各种计费要素
              <span @click="downloadDetails('字段明细', FILEURL.CUSTOMER_MULTI_INFO)">下载各字段明细</span>
            </p>
            <div class="batchBtnStyle" @click="downloadExcelTemplate(TEMPLATETYPE.SPECIAL, TEMPLATETYPE.SPECIAL.type)">
              <img src="@/assets/img/icon/xlsx.png" />
              批量下单模板（使用专用模板）
              <img class="icon_load" :src="typeIndex === UPLOADTYPE.SPECIAL_TEMPLATE ? downloadField : downloads" />
            </div>
          </div>
        </a-col>
        <a-col v-if="nonOperating" :span="11" class="leftStyle product-flg" :offset="0">
          <div
            :class="typeIndex === UPLOADTYPE.SETTLEMENT ? 'radioBox radioBoxActive' : 'radioBox'"
            @click="editTypeIndex(UPLOADTYPE.SETTLEMENT)"
          >
            <img v-if="typeIndex === UPLOADTYPE.SETTLEMENT" class="activeImg" src="@/assets/img/icon_select.png" alt="">
            <p class="exportTitle">结算订单专用模板导入</p>
            <p class="skuStyle">
              表格中填写货品品类，不填写sku明细
            </p>
            <div class="batchBtnStyle" @click="downloadExcelTemplate(TEMPLATETYPE.SETTLEMENT, TEMPLATETYPE.SETTLEMENT.type)">
              <img src="@/assets/img/icon/xlsx.png" />
              批量下单模板（结算订单专用模板）
              <img class="icon_load" :src="typeIndex === UPLOADTYPE.SETTLEMENT ? downloadField : downloads" />
            </div>
          </div>
        </a-col>
        <a-col v-if="isSeaShipping" :span="11" class="leftStyle product-flg" :offset="0">
          <div
            :class="typeIndex === UPLOADTYPE.SETTLEMENT_SEA_TRANSPORT ? 'radioBox radioBoxActive' : 'radioBox'"
            @click="editTypeIndex(UPLOADTYPE.SETTLEMENT_SEA_TRANSPORT)"
          >
            <img v-if="typeIndex === UPLOADTYPE.SETTLEMENT_SEA_TRANSPORT" class="activeImg" src="@/assets/img/icon_select.png" alt="">
            <p class="exportTitle">海运订单导入</p>
            <p class="skuStyle">
              表格支持海运订单的方式下单
            </p>
            <div class="batchBtnStyle" @click="downloadExcelTemplate(TEMPLATETYPE.SETTLEMENT_SEA_TRANSPORT, TEMPLATETYPE.SETTLEMENT_SEA_TRANSPORT.type)">
              <img src="@/assets/img/icon/xlsx.png" />
              批量下单模板（使用海运订单模板）
              <img class="icon_load" :src="typeIndex === UPLOADTYPE.SETTLEMENT_SEA_TRANSPORT ? downloadField : downloads" />
            </div>
          </div>
        </a-col>
        <a-col v-if="isSupplementary" :span="11" class="leftStyle product-flg" :offset="0">
          <div
            :class="typeIndex === UPLOADTYPE.MULTISTAGE_SETTLEMENT ? 'radioBox radioBoxActive' : 'radioBox'"
            @click="editTypeIndex(UPLOADTYPE.MULTISTAGE_SETTLEMENT)"
          >
            <img v-if="typeIndex === UPLOADTYPE.MULTISTAGE_SETTLEMENT" class="activeImg" src="@/assets/img/icon_select.png" alt="">
            <p class="exportTitle">补录订单导入专用</p>
            <p class="skuStyle">
              表格支持补录订单导入专用下单
            </p>
            <div class="batchBtnStyle" @click="downloadExcelTemplate(TEMPLATETYPE.MULTISTAGE_SETTLEMENT, TEMPLATETYPE.MULTISTAGE_SETTLEMENT.type)">
              <img src="@/assets/img/icon/xlsx.png" />
              批量下单模板（使用补录订单专用模板）
              <img class="icon_load" :src="typeIndex === UPLOADTYPE.MULTISTAGE_SETTLEMENT ? downloadField : downloads" />
            </div>
          </div>
        </a-col>
        <a-col v-if="nonOperating && isSettlement" :span="11" class="leftStyle product-flg" :offset="0">
          <div
            :class="typeIndex === UPLOADTYPE.SETTLEMENT_PRICE ? 'radioBox radioBoxActive' : 'radioBox'"
            @click="editTypeIndex(UPLOADTYPE.SETTLEMENT_PRICE)"
          >
            <img v-if="typeIndex === UPLOADTYPE.SETTLEMENT_PRICE" class="activeImg" src="@/assets/img/icon_select.png" alt="">
            <div class="flex justify-between align-center">
              <p class="exportTitle">结算订单专用模板导入</p>
              <span class="tips">自定义应收应付</span>
            </div>
            <p class="skuStyle">
              表格中填写货品品类，不填写sku明细
            </p>
            <div class="batchBtnStyle" @click="downloadExcelTemplate(TEMPLATETYPE.SETTLEMENT_PRICE, TEMPLATETYPE.SETTLEMENT_PRICE.type)">
              <img src="@/assets/img/icon/xlsx.png" />
              批量下单模板（结算订单专用模板）
              <img class="icon_load" :src="typeIndex === UPLOADTYPE.SETTLEMENT_PRICE ? downloadField : downloads" />
            </div>
          </div>
        </a-col>
        <template>
          <!-- v-if="hasWarehouseContract" -->
          <template v-if="!isWmsSystem">
            <a-col class="product-flg" :span="11" :offset="0">
            <div
              :class="typeIndex === WAREHOUSETYPE.WAREHOUSE ? 'radioBox radioBoxActive' : 'radioBox'"
              @click="changeWarehoseType(WAREHOUSETYPE.WAREHOUSE, WAREHOUSETYPE.STORE_V2)"
            >
              <img v-if="typeIndex === WAREHOUSETYPE.WAREHOUSE" class="activeImg" src="@/assets/img/icon_select.png" alt="">
              <p class="exportTitle">仓下单</p>
              <p class="skuStyle">
                运输入库、纯入库、纯出库
              </p>
              <div class="flex">
                <div
                  v-track-click="{trackName:$route.query.menuName?`${$route.query.menuName}-批量导入下单-下载模板-仓入库单模板`:`批量导入下单-下载模板-仓入库单模板`}"
                  class="batchBtnStyle"
                  :class="{batchBtn: true, isActive: typeIndex === 'WAREHOUSE_ONLY' && type === WAREHOUSETYPE.STORE_V2}"
                  @click="e => changeWarehoseType(WAREHOUSETYPE.WAREHOUSE, WAREHOUSETYPE.STORE_V2, e)"
                >
                  <img src="@/assets/img/icon/xlsx.png" />
                  仓入库单模板
                  <img
                    class="icon_load"
                    :src="typeIndex === WAREHOUSETYPE.WAREHOUSE && typeIndex === WAREHOUSETYPE.STORE_V2 ? downloadField : downloads"
                    @click="downloadTemplate('仓入库单模版', WAREHOUSETYPE.STORE_V2, true)"
                  />
              </div>
                <div
                  v-track-click="{trackName:$route.query.menuName?`${$route.query.menuName}-批量导入下单-下载模板-仓出库单模板`:`批量导入下单-下载模板-仓出库单模板`}"
                  class="batchBtnStyle margin"
                  :class="{batchBtn: true, isActive: typeIndex === 'WAREHOUSE_ONLY' && type === WAREHOUSETYPE.DELIVER_ONLY_V2}"
                  @click="e => changeWarehoseType(WAREHOUSETYPE.WAREHOUSE, WAREHOUSETYPE.DELIVER_ONLY_V2, e)"
                >
                  <img src="@/assets/img/icon/xlsx.png" />
                  仓出库单模板
                  <img
                    class="icon_load"
                    :src="typeIndex === WAREHOUSETYPE.WAREHOUSE && typeIndex === WAREHOUSETYPE.DELIVER_ONLY_V2 ? downloadField : downloads"
                    @click="downloadTemplate('仓出库单模版', WAREHOUSETYPE.DELIVER_ONLY_V2, true)"
                  />
                  </div>
              </div>
            </div>
          </a-col>
          <a-col class="leftStyle product-flg" :span="11" :offset="0">
            <div
              :class="typeIndex === WAREHOUSETYPE.TRANSPORT ? 'radioBox radioBoxActive' : 'radioBox'"
              @click="changeWarehoseType(WAREHOUSETYPE.TRANSPORT, WAREHOUSETYPE.DELIVER_TRANSPORT_V2)"
            >
            <img v-if="typeIndex === WAREHOUSETYPE.TRANSPORT" class="activeImg" src="@/assets/img/icon_select.png" alt="">
              <p class="exportTitle">仓配一体下单</p>
              <p class="skuStyle">
                出库与运输一体下单
              </p>
              <div>
                <div
                  v-track-click="{trackName:$route.query.menuName?`${$route.query.menuName}-批量导入下单-下载模板-仓配一体下单导入模板`:`批量导入下单-下载模板-仓配一体下单导入模板`}"
                  class="batchBtnStyle"
                  :class="{batchBtn: true, isActive: type === WAREHOUSETYPE.DELIVER_TRANSPORT_V2}"
                >
                  <img src="@/assets/img/icon/xlsx.png" />
                  仓配一体下单导入模版
                  <img
                    class="icon_load"
                    :src="typeIndex === WAREHOUSETYPE.TRANSPORT && typeIndex === WAREHOUSETYPE.DELIVER_TRANSPORT_V2 ? downloadField : downloads"
                    @click="downloadTemplate('仓配一体下单导入模版', WAREHOUSETYPE.DELIVER_TRANSPORT_V2, true)"
                  />
                  </div>
              </div>
            </div>
          </a-col>
          </template>
          <wmsWarehouseMultiple
            v-else
            :type-index="typeIndex"
            @downloadExcelWareHouse="downloadExcelWareHouse"
            @downloadExcelWareHouseTransport="downloadExcelWareHouseTransport"
            @editTypeIndex="editTypeIndex"
            @downloadTemplate="downloadTemplate"
            @changeWareHouseType="changeType"
            />
        </template>
        
      </a-row>
    </block-title>
  </div>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import downloadField from '@/assets/img/icon/download_field.png'
import downloads from '@/assets/img/icon/download.png'
import { UPLOADTYPE, FILEURL, WAREHOUSETYPE, TEMPLATETYPE, UsualToBusiness } from './multipleConst'
import wmsWarehouseMultiple from './wmsWarehouseMultiple/index.vue'

export default {
  name: 'NoStandardMultiple',
  components: {
    BlockTitle,
    wmsWarehouseMultiple
  },
  props: {
    typeIndex: {
      type: String,
      default: ''
    },
    nonOperating: {
      type: Boolean,
      default: false
    },
    hasWarehouseContract: {
      type: Boolean,
      default: false
    },
    isSeaShipping: {
      type: Boolean,
      default: false
    },
    isSupplementary: {
      type: Boolean,
      default: false
    },
    isSettlement: {
      type: Boolean,
      default: false
    },
    isWmsSystem:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      UPLOADTYPE,
      FILEURL,
      WAREHOUSETYPE,
      TEMPLATETYPE,
      downloadField,
      downloads,
      type: WAREHOUSETYPE.STORE_V2,
    }
  },
  methods: {
    editTypeIndex(index) {
      this.$emit('editTypeIndex', index)
    },
    downloadExcelTemplate(item, index) {
      this.$emit('downloadExcelTemplate', item, index)
    },
    downloadExcelWareHouseTransport(name, type) {
      this.$emit('downloadExcelWareHouseTransport', name, type)
    },
    downloadDetails(name, type) {
      this.$emit('downloadDetails', name, type)
    },
    downloadExcelWareHouse(item, type) {
      this.$emit('downloadExcelWareHouse', item, type)
    },
    downloadTemplate(item, type, isTransport) {
      const innerType = this.isOrderDemoVersion? type : (UsualToBusiness[type]||type)
      this.$emit('downloadTemplate', item, innerType, isTransport)
    },
    changeWarehoseType(index, type, e) {
      this.$emit('editTypeIndex', index);
      this.type = type;
      this.$emit('changeWareHouseType', type);
      if (e) {
        e.stopPropagation();
      }
    },
    changeType(type) {
      this.$emit('changeWareHouseType', type)
    }
  }
}
</script>

<style scoped>
.tips {
  color: red;
}
.margin {
  margin-left: 10px;
}
.batchBtn {
  flex: 1;
}
</style>
